// material import
import {
    Breadcrumbs,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    Grid,
    Link,
    Switch
} from '@material-ui/core';
import { React } from "react";
import { legal_agreement_milk_producer } from '../../common/constants/constants';
import PageHeader from '../../components/pageHeader/pageHeader';

const DataAgreement = (props) => {
    return (
        <article>
            <PageHeader h1={legal_agreement_milk_producer.title}  legal={legal_agreement_milk_producer} />
            <Container maxWidth="md" className="container-align-left">
                <Grid container spacing={3} className="legal-container">
                    <Grid item xs={12} md={12} lg={12}>
                        <div><img src={legal_agreement_milk_producer.logo} alt={legal_agreement_milk_producer.logoAlt} style={{ maxWidth: '40%', marginBottom: '20px' }}/></div>
                        <div className="legal-content" dangerouslySetInnerHTML={{ __html: legal_agreement_milk_producer.legalText }}></div>
                    </Grid>
                </Grid>
            </Container>
        </article>                
    );
};

export default DataAgreement;

